import {containers,actionTypes,uiItemNames,buttonActionTypes,pdfMode, currPathValue,saveButtonMode, wfRetteType} from '../types/enums'
import {ReqError, PaDocument, wfRecipient, wfDocument, OpenFileInfo, RevisionPermisions, activityItem, qsDocument, PaDocumentV2, PaDocumentComments} from '../types/types'
import {ThunkDispatch} from 'redux-thunk'
import {AppActions,ThunkResult,IState} from '../types/types'
import {callProArcApi, callProArcApiDelete, callProArcApiGet} from '../components/helpers/proarcApiHelpers';
import store from '../configureStore';
import { getMyActivitiesJson, getRecentDocumentsJson, startWfJson} from './jsons';
import { setAppSettings, setStateItem, setUiProperty } from './actionsBase';

const apiUrl = "__API_URL__";

export function setContainersVisible():ThunkResult<void> {
    console.log("setContainersVisible");
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
                dispatch(setUiProperty(actionTypes.SET_VISIBLE,containers.MAIN_CONTAINER, true));
                dispatch(setUiProperty(actionTypes.SET_LOADING, containers.MAIN_CONTAINER, true));
                
                const json = {
                    "repositoryRno": 0,
                    "section": "ANNORAIL"
                  }; 
                dispatch(()=>callProArcApi(buttonActionTypes.GET_CONFIG,json,"")
                    .then((response)=>{
                        if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                            {
                                console.log("Error");
                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response)));    
                            }
                        else
                            {
                                //store config
                                dispatch(setAppSettings(actionTypes.SET_APP_SETINGS, JSON.parse((response as any)[0].value)));    

                                //getCurentUser
                                dispatch(()=>callProArcApiGet(buttonActionTypes.GET_MY_INFO,"","")
                                .then((response)=>{
                                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                        {
                                            console.log("Error");
                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response)));    
                                        }
                                    else
                                        {
                                            //get groups
                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.currentUser, response));  
                                            let json:any = {};
                                            dispatch(()=>callProArcApi(buttonActionTypes.GET_MY_GROUPS,json,store.getState().uiItems.currentUser.userRno.toString(),"")
                                                .then((response)=>{
                                                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                                        {
                                                            console.log("Error");
                                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response)));    
                                                        }
                                                    else
                                                        {
                                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.currentUserGroups, (response as unknown as any).items));
                                                            console.log("groups",store.getState().uiItems.currentUserGroups);
                                                            // Convert comma-separated string to array
                                                            const requiredGroups = store.getState().appSettings.requiredGroups.split(",").map(g => g.trim());
                                                            // Check if user belongs to ANY of these groups
                                                            const isInGroup = store.getState().uiItems.currentUserGroups.some(userGroup =>
                                                                requiredGroups.includes(userGroup.id)
                                                                );
                                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.hasRequiredGroups, isInGroup));
                                                            if(isInGroup)
                                                            {
                                                                dispatch(setUiProperty(actionTypes.SET_LOADING, containers.MAIN_CONTAINER, false));
                                                            //     // //load favorites
                                                            //     // let json:any = getRecentDocumentsJson;        
                                                            //     // dispatch(()=>callProArcApi(buttonActionTypes.GET_FAVORITE_DOCS,json,"")
                                                            //     //     .then((response)=>{
                                                            //     //             if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                                            //     //             {
                                                            //     //                 console.log("Error");
                                                            //     //                 dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response)));      
                                                            //     //                 dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.MAIN_CONTAINER, true));
                                                            //     //                 dispatch(setUiProperty(actionTypes.SET_LOADING, containers.MAIN_CONTAINER, false));
                                                            //     //             }
                                                            //     //             else
                                                            //     //             {
                                                            //     //                 console.log("Success");
                                                            //     //                 dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.favoriteDocuments, (response as unknown as any).items.filter((x:PaDocumentV2)=>x.repositoryRno===30)));
                                                            //     //                 dispatch(setUiProperty(actionTypes.SET_LOADING, containers.MAIN_CONTAINER, false));
                                                            //     //             }
                                                            //     //         }) 
                                                            //     //     )  

                                                            }
                                                            else
                                                            {
                                                                //user does not have required groups
                                                                console.log("Error: user does not have required groups");
                                                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify("You do not have required permissions to use this app, contact administrator!")));  
                                                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.currentPath, currPathValue.NoAccess));  
                                                                dispatch(setUiProperty(actionTypes.SET_LOADING, containers.MAIN_CONTAINER, false));
                                                            }
                                                        }
                                            }))
                                        }
                                    }))
                            }
                        })
                        .catch(error=>
                            {
                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(error)));      
                                dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.MAIN_CONTAINER, true));
                                dispatch(setUiProperty(actionTypes.SET_LOADING, containers.MAIN_CONTAINER, false));
                            }
                        )    
                )
    }            
};

export function SearchClick(value:string):ThunkResult<void> {
    console.log("SearchClick", value);
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
        
        dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DATA_CONTAINER, true));
        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.currentPath, currPathValue.Search)); 
        dispatch(SetErrorMsgVisible(false));

        let json = {
            "searchText": value,
            "includeVoided": false,
            "revisionOption": 0,
            "presentation": {
                "documentMetaItems": [
                  "status", "revision","RepositoryName"
                ],
              }
          };
        dispatch(()=>callProArcApi(buttonActionTypes.SEARCH_DOCS,json,"")
            .then((response)=>{
                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                    {
                        console.log("Error");
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                        dispatch(SetErrorMsgVisible(true));
                        dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DATA_CONTAINER, false));
                    }
                    else
                    {
                        console.log("Success");
                        //set revision to update
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentSearchList, 
                            (response as unknown as any).items.filter((x:qsDocument)=>x.repositoryRno === 30)
                                .map((x:qsDocument) => {return  {
                                                                    repositoryRno: x.repositoryRno,
                                                                    documentRno: x.rno,
                                                                    documentId: x.id,
                                                                    documentTitle: x.title,
                                                                    status: x.documentMetaItems.status,
                                                                    repositoryName: x.documentMetaItems.RepositoryName, 
                                                                }
                                                        })));
                        dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DATA_CONTAINER, false));
                    }
                })
                .catch(error=>
                    {
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(error))); 
                        dispatch(SetErrorMsgVisible(true));
                        dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DATA_CONTAINER, false));
                    }
                ) 
            )
    }
}


export function AddComment(docRno:number,commLevel:number,commInput:string,wfRno?:number,actRno?:number,file?:Blob, filename?: string, revRno?:number):ThunkResult<void> 
{
    console.log("AddComment");
    if(file===undefined)
    {
        if(store.getState().uiItems.currentPath === currPathValue.WfActivity)
        {
            return AddActComment(wfRno!,actRno!,docRno,commLevel,commInput);
        }
        else
        {
            return AddDocComment(docRno,commLevel, commInput);
        }
    }
    else
    {
        return AddCommentWithAttachment(file,filename!,docRno,revRno!,commInput,commLevel)
    }
}

export function AddActComment(wfRno:number,actRno:number,docRno:number,commLevel:number,commInput:string):ThunkResult<void> {
    console.log("AddActComment", wfRno,actRno,docRno,commLevel,commInput);
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
        dispatch(setUiProperty(actionTypes.SET_LOADING, containers.ACTIVITY_DATA_CONTAINER, true));
        dispatch(SetErrorMsgVisible(false));

        let json = {
            "commentRno": 0,
            "comment": commInput,
            "commentedByUserId": store.getState().oidc?.profile.sub,
            "commentType": commLevel,
            "workflowRno": wfRno,
            "activityRno": actRno,
            "documentRno": docRno
            //"revisionRno": 3, to add to specific revision
        };
       
        dispatch(()=>callProArcApi(buttonActionTypes.ADD_WF_COMMENT,json,wfRno.toString(),actRno.toString())
            .then((response)=>{
                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                    {
                        console.log("Error");
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                        dispatch(SetErrorMsgVisible(true));
                        dispatch(setUiProperty(actionTypes.SET_LOADING, containers.ACTIVITY_DATA_CONTAINER, false));
                    }
                    else
                    {
                        console.log("Success comment added");
                        //set revision to update
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentSearchList, (response as unknown as any).items));
                        getActComments(dispatch,wfRno,actRno)
                            .then(()=>{
                                
                                console.log("Add attachments info from doc comms if present");
                                let sellActivty:activityItem = store.getState().uiItems.selectedActivity!;
                                const comms = sellActivty.WfComments.map(x=>{
                                    const commId = x.commentRno;
                                    const allPaComments = sellActivty.PaDocuments.flatMap(doc => doc.Comments);
                                    if(allPaComments.filter(x=>x.CommentId === commId).length>0)
                                    {
                                        console.log("add attachment info to comment")
                                        x.Attachments = allPaComments.filter(x=>x.CommentId === commId)[0].Attachments;
                                    }
                                    else
                                    {
                                        x.Attachments = [];
                                    }
                                    return x;
                                });
                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.wfDocuments, {Attribute: "WfComments", Value: comms } ));
                                console.log("Comments reloaded");
                                dispatch(setUiProperty(actionTypes.SET_LOADING, containers.ACTIVITY_DATA_CONTAINER, false));
                            })
                    }
                })
                .catch(error=>
                    {
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(error))); 
                        dispatch(SetErrorMsgVisible(true));
                        dispatch(setUiProperty(actionTypes.SET_LOADING, containers.ACTIVITY_DATA_CONTAINER, false));
                    }
                ) 
            )
    }
}

export function AddDocComment(docRno:number,commLevel:number, commInput:string):ThunkResult<void> {
    console.log("AddDocComment", docRno,commInput);
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
        dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DOC_DATA_CONTAINER, true));
        dispatch(SetErrorMsgVisible(false));
        

        let json = {
            "commentRno": 0,
            "comment": commInput,
            "commentedByUserId": store.getState().oidc?.profile.sub,
            "commentType": commLevel,
            "documentRno": docRno
            //"revisionRno": 3, to add to specific revision
          };
       
        dispatch(()=>callProArcApi(buttonActionTypes.ADD_DOC_COMMENT,json,docRno.toString())
            .then((response)=>{
                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                    {
                        console.log("Error");
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                        dispatch(SetErrorMsgVisible(true));
                        dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DOC_DATA_CONTAINER, false));
                    }
                    else
                    {
                        console.log("Success comment added");
                        //set revision to update
                        let JsonPostDocuments = {
                            "docRnos": [-1],
                            "returnOptions": "All"
                            };
                        JsonPostDocuments.docRnos = [docRno];
        
                        dispatch(()=>callProArcApi(buttonActionTypes.GET_DOCUMENTS,JsonPostDocuments,"")
                        .then((response)=>{
                                if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                {
                                    console.log("Error");
                                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                                    dispatch(SetErrorMsgVisible(true));
                                    dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DOC_DATA_CONTAINER, false));
                                }
                                else
                                {
                                    console.log("Success");
                                    const permisions = JSON.parse(JSON.stringify(store.getState().uiItems.selectedDocument!.SelectedRevPermisions));
                                    let doc = (response as any as PaDocument[])[0];
                                    doc.WfComments = doc.Comments.map(x=> {
                                        //let att = x.Attachments.map(y=>{return {"FileRno": y.FileRno, "OriginalFileName": y.OriginalFileName }})
                                        return {
                                            "commentRno": x.CommentId,
                                            "comment": x.Text,
                                            "commentedByUserName": x.CommentedBy.FullName,
                                            "created": x.Created,
                                            "activityName": x.DocumentInfo.ActivityItem.ActivityTemplate.Name,
                                            "docId": x.DocumentInfo.DocId,
                                            "revisionId": x.DocumentInfo.RevisionId,
                                            "commentedByUserRno": x.CommentedBy.UserRno,
                                            "commentedByUserId": x.CommentedBy.UserId,
                                            "commentSequence": x.CommentSequence,
                                            "commentType": x.CommentType,
                                            "fileRno": -1,
                                            "isDeleted": false,
                                            "parentCommentRno": x.ParentCommentId,
                                            "attachmentsCount": -1,
                                            "fileName": "",
                                            "documentRno": x.DocumentInfo.DocRno,
                                            "revisionRno": x.DocumentInfo.RevisionRno,
                                            "repositoryRno": x.DocumentInfo.ArchiveId,
                                            "workflowRno": -1,
                                            "workflowTemplateRno": -1,
                                            "workflowClassRno": -1,
                                            "workflowName": "",
                                            "activityRno": -1,
                                            "activityId": -1,
                                            "Attachments": x.Attachments.map(y=>{return {"FileRno": y.FileRno, "OriginalFileName": y.OriginalFileName, "Extension": y.Extension }})
                                        }
                                    })
                                    doc.SelectedRevPermisions = permisions;
                                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.selectedDocument, doc));
                                    dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DOC_DATA_CONTAINER, false));
                                }
                            }))
                    }
                })
                .catch(error=>
                    {
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(error))); 
                        dispatch(SetErrorMsgVisible(true));
                        dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DOC_DATA_CONTAINER, false));
                    }
                ) 
            )
    }
}

export function AddCommentWithAttachment(blob:Blob,filename:string, docRno:number, revRno:number,commInput:string, commLevel:number):ThunkResult<void> {
    console.log("AddCommentWithAttachment")
    const WFcontainer = store.getState().uiItems.currentPath === currPathValue.WfActivity;

    console.log("ImportFile WFContainer",WFcontainer)
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
            //upload syncronously               
            let p = Promise.resolve();
            let pathOnServer ="";
            
            dispatch(setUiProperty(actionTypes.SET_LOADING, WFcontainer ? containers.ACTIVITY_DATA_CONTAINER : containers.DOC_DATA_CONTAINER , true));
            
            dispatch(()=>p = p.then(() => 
                {
                    console.log("Upload file", filename);
                    if(blob.size<20000000)
                    {
                        return uploadBlobToDssWithoutChunking(blob,filename)
                            .then(response => response.json())
                            .then(success => {
                                console.log("uploadFileToDss With OUT Chunking success", success);
                                pathOnServer = success.serverFilePath;
                            })
                            .catch(error => {
                                console.log("catch upload file",error);
                                pathOnServer = "";
                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(error)));      
                                dispatch(setUiProperty(actionTypes.SET_LOADING, WFcontainer ? containers.ACTIVITY_DATA_CONTAINER : containers.DOC_DATA_CONTAINER , false));
                                dispatch(setUiProperty(actionTypes.SET_ERRORED, WFcontainer ? containers.ACTIVITY_DATA_CONTAINER : containers.DOC_DATA_CONTAINER , false));
                            }); 
                    }
                    else
                    {
                        return uploadBlobToDssWithChunking(blob,filename, dispatch)
                            .then(response => response.json())
                            .then(success => {
                                console.log("uploadFileToDss With Chunking success", success);
                                pathOnServer = success.serverFilePath;
                            })
                            .catch(error => {
                                console.log("catch upload file",error);
                                pathOnServer = "";
                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(error)));      
                                dispatch(setUiProperty(actionTypes.SET_LOADING, WFcontainer ? containers.ACTIVITY_DATA_CONTAINER : containers.DOC_DATA_CONTAINER , false));
                                dispatch(setUiProperty(actionTypes.SET_ERRORED, WFcontainer ? containers.ACTIVITY_DATA_CONTAINER : containers.DOC_DATA_CONTAINER , false));
                            }); 
                    }
                })
                .then(()=> {
                        //as comment and attachment
                        //const openedFile = store.getState().uiItems.OpenFileInfo.File;
                        let json:any = {
                            "commentRno": 0,
                            "comment": commInput,
                            "commentedByUserId": store.getState().oidc?.profile.sub,
                            "commentType": commLevel,
                            "documentRno": docRno
                            //"revisionRno": 3, to add to specific revision
                        };
                        let action = buttonActionTypes.ADD_DOC_COMMENT;
                        

                        if(store.getState().uiItems.currentPath === currPathValue.WfActivity)
                        {
                            action = buttonActionTypes.ADD_WF_COMMENT;
                            json = {
                                "commentRno": 0,
                                "comment": commInput,
                                "commentedByUserId": store.getState().oidc?.profile.sub,
                                "commentType": commLevel,
                                "workflowRno": store.getState().uiItems.selectedActivity!.WorkflowItem.Id,
                                "activityRno": store.getState().uiItems.selectedActivity!.Id,
                                "documentRno": docRno,
                                "revisionRno": revRno
                            };    
                        }

                        return dispatch(()=>
                            (action === buttonActionTypes.ADD_WF_COMMENT ? callProArcApi(buttonActionTypes.ADD_WF_COMMENT,json,store.getState().uiItems.selectedActivity!.WorkflowItem.Id.toString(),store.getState().uiItems.selectedActivity!.Id.toString())
                                :callProArcApi(buttonActionTypes.ADD_DOC_COMMENT,json,docRno.toString()))
                            .then((response)=>{
                                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                    {
                                        console.log("Error");
                                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                                        dispatch(SetErrorMsgVisible(true));
                                        dispatch(setUiProperty(actionTypes.SET_LOADING, WFcontainer ? containers.ACTIVITY_DATA_CONTAINER : containers.DOC_DATA_CONTAINER , false));
                                    }
                                    else
                                    {
                                        console.log("Success comment added");
                                        //console.log(response);
                                        // const obj = {
                                        //   "rel": "GetWorkflowActivityComment",
                                        //   "href": "/api/workflow/418490/activity/1299142/comments/230130",
                                        //   "method": "GET"
                                        // };

                                        const href = (response as unknown as any).href;
                                        const commNumber = href.substring(href.lastIndexOf('/') + 1);
                                        //add comment file
                                        console.log("pathOnServer",pathOnServer);
                                        const JsonImportCommFIle= {
                                            "commentFiles":[
                                                {
                                                    "CommentId": commNumber,
                                                    "Name": "retteunderlag.pdf",
                                                    "OriginalFileName": filename,
                                                    "MetaItems":[
                                                            {	
                                                                "Name":"FilePath",
                                                                "Value": pathOnServer,
                                                                "HasMultipleValues":false
                                                            }
                                                        ],
                                                    "DocRno": docRno
                                                }
                                            ]
                                        }
   
                                        console.log("Import com file");
                                        return dispatch(()=> 
                                            callProArcApi(buttonActionTypes.IMPORT_COMM_FILE,JsonImportCommFIle,"")
                                                    .then((response)=>{
                                                            if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                                            {
                                                                console.log("Error import comm file");
                                                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response)));          
                                                                dispatch(setUiProperty(actionTypes.SET_LOADING, WFcontainer ? containers.ACTIVITY_DATA_CONTAINER : containers.DOC_DATA_CONTAINER , false));
                                                                dispatch(setUiProperty(actionTypes.SET_ERRORED, WFcontainer ? containers.ACTIVITY_DATA_CONTAINER : containers.DOC_DATA_CONTAINER , false));
                                                            }
                                                            else
                                                            {
                                                                console.log("Success import comm file - reload" );
                                                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify({succeded: true, Message:"Comm file imported"})));

                                                                let JsonPostDocuments = {
                                                                    "docRnos": [-1],
                                                                    "returnOptions": "All"
                                                                    };

                                                                if(WFcontainer)
                                                                {
                                                                    const selectedAct = store.getState().uiItems.selectedActivity;                                                                
                                                                    //find and reload correct comment file instead here
                                                                    JsonPostDocuments.docRnos = selectedAct!.WfDocuments.map((x:wfDocument)=>x.documentRno);
                                                    
                                                                    return callProArcApi(buttonActionTypes.GET_DOCUMENTS,JsonPostDocuments,"")
                                                                        .then((response)=>{
                                                                                if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                                                                {
                                                                                    console.log("Error getPaDocuments");
                                                                                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                                                                                    dispatch(SetErrorMsgVisible(true));
                                                                                }
                                                                                else
                                                                                {
                                                                                    console.log("Success getPaDocuments");
                                                                                    let wfDocs = (response as any as PaDocument[]);
                                                                                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.wfDocuments, {Attribute: "PaDocuments", Value: wfDocs } ));
                                                                                    const act = store.getState().uiItems.selectedActivity!;
                                                                                    // const allComments:PaDocumentComments[] = act.PaDocuments.flatMap((doc:PaDocument) => doc.Comments);
                                                                                    // const commentJustsaved= allComments.filter(x=>x.CommentId.toString() === commNumber.toString())[0];
                                                                                    // const lastAttachemnt = commentJustsaved.Attachments[commentJustsaved.Attachments.length - 1];

                                                                                    return getActComments(dispatch,act.WorkflowItem.Id,act.Id)
                                                                                            .then(()=>{
                                                                                                console.log("Success comments refreshed");
                                                                                                console.log("Add attachments info from doc comms if present");
                                                                                                let sellActivty:activityItem = store.getState().uiItems.selectedActivity!;
                                                                                                const comms = sellActivty.WfComments.map(x=>{
                                                                                                    const commId = x.commentRno;
                                                                                                    const allPaComments = sellActivty.PaDocuments.flatMap(doc => doc.Comments);
                                                                                                    if(allPaComments.filter(x=>x.CommentId === commId).length>0)
                                                                                                    {
                                                                                                        console.log("add attachment info to comment")
                                                                                                        x.Attachments = allPaComments.filter(x=>x.CommentId === commId)[0].Attachments;
                                                                                                    }
                                                                                                    else
                                                                                                    {
                                                                                                        x.Attachments = [];
                                                                                                    }
                                                                                                    return x;
                                                                                                });
                                                                                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.wfDocuments, {Attribute: "WfComments", Value: comms } ));
                                                                                               console.log("Comments reloaded");
                                                                                                dispatch(setUiProperty(actionTypes.SET_LOADING, containers.ACTIVITY_DATA_CONTAINER, false));
                                                                                            })             

                                                                                }
                                                                            })
                                                                }
                                                                else
                                                                {
                                                                    JsonPostDocuments.docRnos = [docRno];
                                                                    return callProArcApi(buttonActionTypes.GET_DOCUMENTS,JsonPostDocuments,"")
                                                                        .then((response)=>{
                                                                                if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                                                                {
                                                                                    console.log("Error");
                                                                                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                                                                                    dispatch(SetErrorMsgVisible(true));
                                                                                    dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DOC_DATA_CONTAINER, false));
                                                                                }
                                                                                else
                                                                                {
                                                                                    console.log("Success");
                                                                                    const permisions = JSON.parse(JSON.stringify(store.getState().uiItems.selectedDocument!.SelectedRevPermisions));
                                                                                    let doc = (response as any as PaDocument[])[0];
                                                                                    doc.WfComments = doc.Comments.map(x=> {
                                                                                        //let att = x.Attachments.map(y=>{return {"FileRno": y.FileRno, "OriginalFileName": y.OriginalFileName }})
                                                                                        return {
                                                                                            "commentRno": x.CommentId,
                                                                                            "comment": x.Text,
                                                                                            "commentedByUserName": x.CommentedBy.FullName,
                                                                                            "created": x.Created,
                                                                                            "activityName": x.DocumentInfo.ActivityItem.ActivityTemplate.Name,
                                                                                            "docId": x.DocumentInfo.DocId,
                                                                                            "revisionId": x.DocumentInfo.RevisionId,
                                                                                            "commentedByUserRno": x.CommentedBy.UserRno,
                                                                                            "commentedByUserId": x.CommentedBy.UserId,
                                                                                            "commentSequence": x.CommentSequence,
                                                                                            "commentType": x.CommentType,
                                                                                            "fileRno": -1,
                                                                                            "isDeleted": false,
                                                                                            "parentCommentRno": x.ParentCommentId,
                                                                                            "attachmentsCount": -1,
                                                                                            "fileName": "",
                                                                                            "documentRno": x.DocumentInfo.DocRno,
                                                                                            "revisionRno": x.DocumentInfo.RevisionRno,
                                                                                            "repositoryRno": x.DocumentInfo.ArchiveId,
                                                                                            "workflowRno": -1,
                                                                                            "workflowTemplateRno": -1,
                                                                                            "workflowClassRno": -1,
                                                                                            "workflowName": "",
                                                                                            "activityRno": -1,
                                                                                            "activityId": -1,
                                                                                            "Attachments": x.Attachments.map(y=>{return {"FileRno": y.FileRno, "OriginalFileName": y.OriginalFileName, "Extension": y.Extension }})
                                                                                        }
                                                                                    })
                                                                                    doc.SelectedRevPermisions = permisions;
                                                                                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.selectedDocument, doc));
                                                                                    dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DOC_DATA_CONTAINER, false));
                                                                                }
                                                                            })
                                                                }

                                                                
                                                            }
                                                        })
                                                )
                                    }
                                }) 
                            )
                    
                })
                .catch(error => {
                    console.log(error);
                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(error)));      
                    dispatch(setUiProperty(actionTypes.SET_LOADING,containers.PDF_VIEWER_CONTAINER, false));
                    dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.PDF_VIEWER_CONTAINER, false));
                })
            );   
    }
}



export function GetListData(path:currPathValue):ThunkResult<void> {
    console.log("GetData for container", path);
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
        
        dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DATA_CONTAINER, true));
        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.currentPath, path));  
        dispatch(SetErrorMsgVisible(false));

        //let json:any = getRecentDocumentsJson;
        let json:any = {};
        if(path===currPathValue.Activities)
        {
            json = getMyActivitiesJson;
            json.activityFilter.ActivityFilterType = "AllActivities";
        }
        let action:any = buttonActionTypes.GET_RECENT_DOCS;
        if(path===currPathValue.Favorites) {action = buttonActionTypes.GET_FAVORITE_DOCS}
        if(path===currPathValue.Activities) {action = buttonActionTypes.GET_MY_ACTIVITIES}
        
        dispatch(()=>callProArcApi(action,json,"")
            .then((response)=>{
                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                    {
                        console.log("Error");
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                        dispatch(SetErrorMsgVisible(true));
                        dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DATA_CONTAINER, false));
                    }
                    else
                    {
                        console.log("Success");
                        //set items to update
                        if(path===currPathValue.Recent) {
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.recentDocuments, (response as unknown as any).items.filter((x:PaDocumentV2)=>x.repositoryRno===30)));
                        }
                        if(path===currPathValue.Favorites) {
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.favoriteDocuments, (response as unknown as any).items.filter((x:PaDocumentV2)=>x.repositoryRno===30)));
                        }
                        if(path===currPathValue.Activities) {
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.myActivities, response));
                        } 

                        dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DATA_CONTAINER, false));
                    }
                })
                .catch(error=>
                    {
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(error))); 
                        dispatch(SetErrorMsgVisible(true));
                        dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DATA_CONTAINER, false));
                    }
                ) 
            )
    }
}

export function GetWfActivity(wfRno:number, actRno:number, headerText:string):ThunkResult<void> {
    console.log("GetWfActivity", actRno, headerText);
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
                 
                //-- set to acknowledged if needed--
                if( store.getState().uiItems.myActivities.filter((x:activityItem)=>x.Id === actRno).length === 0 
                        ? "" : store.getState().uiItems.myActivities.filter((x:activityItem)=>x.Id === actRno)[0].AcknowledgedDate.toString()  ==="0001-01-01T00:00:00")
                {
                    console.log("Acknowledge this act.");
                    callProArcApi(buttonActionTypes.ACK_ACTIVITY,"",wfRno.toString(),actRno.toString());
                }
                
                // ------------------------

                dispatch(setUiProperty(actionTypes.SET_LOADING, containers.ACTIVITY_DATA_CONTAINER, true));
                dispatch(SetErrorMsgVisible(false));

                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.headerText, headerText));  
                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.currentPath, currPathValue.WfActivity));
                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.previousPath, [currPathValue.Activities])); 

                const selectedAct = store.getState().uiItems.myActivities.filter((x:activityItem)=>x.Id === actRno)[0];
                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.selectedActivity, selectedAct));

                Promise.all([   getActDecisions(dispatch,wfRno,actRno),
                                getActDocuments(dispatch,wfRno),
                                getActComments(dispatch,wfRno,actRno),
                                getActRecsBL(dispatch,wfRno),
                                getActItemBL(dispatch,actRno)
                    ])
                    .then(()=>{
                            console.log("Pormise all success");

                            let JsonPostDocuments = {
                                "docRnos": [-1],
                                "returnOptions": "All"
                                };
                            JsonPostDocuments.docRnos = store.getState().uiItems.selectedActivity!.WfDocuments.map((x:wfDocument)=>x.documentRno);
            
                            return callProArcApi(buttonActionTypes.GET_DOCUMENTS,JsonPostDocuments,"")
                                .then((response)=>{
                                        if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                        {
                                            console.log("Error getPaDocuments");
                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                                            dispatch(SetErrorMsgVisible(true));
                                        }
                                        else
                                        {
                                            console.log("Success getPaDocuments");
                                            let wfDocs = (response as any as PaDocument[]);
                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.wfDocuments, {Attribute: "PaDocuments", Value: wfDocs } ));

                                            console.log("Add attachments info from doc comms if present");
                                            let sellActivty:activityItem = store.getState().uiItems.selectedActivity!;
                                            const comms = sellActivty.WfComments.map(x=>{
                                                const commId = x.commentRno;
                                                const allPaComments = sellActivty.PaDocuments.flatMap(doc => doc.Comments);
                                                if(allPaComments.filter(x=>x.CommentId === commId).length>0)
                                                {
                                                    console.log("add attachment info to comment")
                                                    x.Attachments = allPaComments.filter(x=>x.CommentId === commId)[0].Attachments;
                                                }
                                                else
                                                {
                                                    x.Attachments = [];
                                                }
                                                return x;
                                            });
                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.wfDocuments, {Attribute: "WfComments", Value: comms } ));

                                            console.log(store.getState().uiItems.selectedActivity!.WfDocuments);
                                            const revPermsToGet = store.getState().uiItems.selectedActivity!.WfDocuments.map((values:wfDocument) => getRevPermisions(dispatch,values.documentRno,values.revisionRno));

                                            Promise.all(revPermsToGet)
                                                        .then(()=> {
                                                            console.log("All done!");
                                                            dispatch(setUiProperty(actionTypes.SET_LOADING, containers.ACTIVITY_DATA_CONTAINER, false));
                                                        })

                                        }
                                })
                    })
                    .catch(error=>
                        {
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(error))); 
                            dispatch(SetErrorMsgVisible(true));
                            dispatch(setUiProperty(actionTypes.SET_LOADING, containers.ACTIVITY_DATA_CONTAINER, false));
                        }
                    ) 
            }
}     

function getActDecisions(dispatch:ThunkDispatch<IState,undefined,AppActions>,wfRno:number,actRno:number):Promise<void>
{
    return  callProArcApiGet(buttonActionTypes.GET_ACTIVITY_DECISIONS, wfRno.toString(),actRno.toString())
                .then((response)=>{
                        if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                        {
                            console.log("Error");
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                            dispatch(SetErrorMsgVisible(true));
                        }
                        else
                        {
                            console.log("Success getActDecisions");
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.wfDocuments, {Attribute: "Decisions", Value: response } ));
                        }
                })
}

function getActComments(dispatch:ThunkDispatch<IState,undefined,AppActions>,wfRno:number,actRno:number):Promise<void>
{
    return  callProArcApi(buttonActionTypes.GET_WF_COMMENTS, {}, wfRno.toString(),actRno.toString())
                .then((response)=>{
                        if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                        {
                            console.log("Error");
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                            dispatch(SetErrorMsgVisible(true));
                        }
                        else
                        {
                            console.log("Success getActComments");
                            const comms = (response as any).items; 
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.wfDocuments, {Attribute: "WfComments", Value: comms } ));
                        }
                })
}

function getActDocuments(dispatch:ThunkDispatch<IState,undefined,AppActions>,wfRno:number):Promise<void>
{
    return  callProArcApi(buttonActionTypes.GET_ACTIVITY_DOCUMENTS,"", wfRno.toString())
                .then((response)=>{
                        if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                        {
                            console.log("Error");
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                            dispatch(SetErrorMsgVisible(true));
                        }
                        else
                        {
                            console.log("Success getActDocuments");
                            let docs = (response as any).items;
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.wfDocuments, {Attribute: "WfDocuments", Value: docs } ));

                            // // dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.wfDocuments, docs));
                            // let JsonPostDocuments = {
                            //     "docRnos": [-1],
                            //     "returnOptions": "All"
                            //     };
                            // JsonPostDocuments.docRnos = (docs as any as wfDocument[]).map(x=>x.documentRno);
            
                            // return callProArcApi(buttonActionTypes.GET_DOCUMENTS,JsonPostDocuments,"")
                            //     .then((response)=>{
                            //             if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                            //             {
                            //                 console.log("Error getPaDocuments");
                            //                 dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                            //                 dispatch(SetErrorMsgVisible(true));
                            //             }
                            //             else
                            //             {
                            //                 console.log("Success getPaDocuments");
                            //                 let wfDocs = (response as any as PaDocument[]);
                            //                 dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.wfDocuments, {Attribute: "PaDocuments", Value: wfDocs } ));
                            //             }
                            //     })
                        }
                    })
}

function getActItemBL(dispatch:ThunkDispatch<IState,undefined,AppActions>,actRno:number):Promise<void>
{
    const json = {"activityItemId": actRno};
    return  callProArcApi(buttonActionTypes.GET_ACTIVITY_BL, json,"")
                .then((response)=>{
                        if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                        {
                            console.log("Error");
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                            dispatch(SetErrorMsgVisible(true));
                        }
                        else
                        {
                            console.log("Success getActItemBL");
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.actItemBL, response ));
                        }
                })
}

function getActRecsBL(dispatch:ThunkDispatch<IState,undefined,AppActions>,wfRno:number):Promise<void>
{
    const json = {"workflowItemId": wfRno};
    return  callProArcApi(buttonActionTypes.GET_ACT_REC_BL, json, "")
                .then((response)=>{
                        if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                        {
                            console.log("Error");
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                            dispatch(SetErrorMsgVisible(true));
                        }
                        else
                        {
                            console.log("Success getActRecsBL");
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.actRecsBL, response ));
                        }
                })
}

function getRevPermisions(dispatch:ThunkDispatch<IState,undefined,AppActions>,docRno:number,revRno:number):Promise<void>
{
    let JsonPostRevPermisions = {
        "docRno": docRno,
        "revRno": revRno
    };
    const revPerms:RevisionPermisions[] = store.getState().uiItems.revisionPermisions;
    if(revPerms.filter(x=>x.DocRno === docRno && x.RevRno === revRno).length === 0)
    {
        return callProArcApi(buttonActionTypes.GET_REVISION_PERMISIONS,JsonPostRevPermisions,"")
            .then((response)=>{
                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                    {
                        console.log("Error");
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                        dispatch(SetErrorMsgVisible(true));
                    }
                    else
                    {
                        console.log("Success");
                        // dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, okEmptyResponse));
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.revisionPermisions, [response] ));
                    }
            })
    }
    else
    {
        return Promise.resolve();
    }
}

export function closeActivityWrapper(wfRno:number,actRno:number,decision:string):ThunkResult<void>
{
    if(decision === "") 
    {
        return closeActivity(wfRno,actRno,decision);        
    }
    else
    {
        return closeActivityBL(wfRno,actRno,decision);
    }
}

export function closeActivityBL(wfRno:number,actRno:number,decision:string):ThunkResult<void>
{
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{

        dispatch(setUiProperty(actionTypes.SET_LOADING, containers.ACTIVITY_DATA_CONTAINER, true));
        dispatch(SetErrorMsgVisible(false));
   
        let JsonPost = {
            "endActivityArguments": {
                "CloseWorkflowOnEmptyActivitySettingValidated": false,
                "ForceClose": false,
                "CloseDate": new Date().toISOString().substring(0,19),
                "workflowStartOptions": {}, 
                "Item": {},
                "Choice": {},
                "Recipients": []
            }
          };
        JsonPost.endActivityArguments.Item = store.getState().uiItems.actItemBL;
        JsonPost.endActivityArguments.Choice = decision === "" ? {} : store.getState().uiItems.actItemBL.ActivityTemplate.ActivityChoices.filter((x:any)=>x.Choice.toUpperCase() === decision.toUpperCase())[0];    
        JsonPost.endActivityArguments.Recipients = store.getState().uiItems.actRecsBL.map((r:any) => ({
                                                                                                    ...r,
                                                                                                    ClosedByUser: {}
                                                                                                    }));

        dispatch(()=>callProArcApi(buttonActionTypes.CLOSE_ACTIVITY_BL ,JsonPost,"")
        .then((response)=>{
                if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                {
                    console.log("Error");
                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                    dispatch(SetErrorMsgVisible(true));
                    dispatch(setUiProperty(actionTypes.SET_LOADING, containers.ACTIVITY_DATA_CONTAINER, false));
                }
                else
                {
                    if((response as any)._succeeded === false)
                    {
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                        dispatch(SetErrorMsgVisible(true));
                        dispatch(setUiProperty(actionTypes.SET_LOADING, containers.ACTIVITY_DATA_CONTAINER, false));
                    }
                    else
                    {
                        //reload activities list
                        let json = getMyActivitiesJson;
                        json.activityFilter.ActivityFilterType = "AllActivities";
                        dispatch(()=>callProArcApi(buttonActionTypes.GET_MY_ACTIVITIES,json,"")
                            .then((response)=>{
                                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                    {
                                        console.log("Error");
                                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                                        dispatch(SetErrorMsgVisible(true));
                                        dispatch(setUiProperty(actionTypes.SET_LOADING, containers.ACTIVITY_DATA_CONTAINER, false));
                                    }
                                    else
                                    {
                                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.myActivities, response));
                                        //reload activity
                                        const hText = store.getState().uiItems.headerText;
                                        dispatch(GetWfActivity(wfRno,actRno,hText));  
                                    }      
                                }
                            )
                        )
                    }
                }
            })
            .catch(error=>
                {
                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(error))); 
                    dispatch(SetErrorMsgVisible(true));
                    dispatch(setUiProperty(actionTypes.SET_LOADING, containers.ACTIVITY_DATA_CONTAINER, false));
                }
            ) 
        )
    }
}

export function closeActivity(wfRno:number,actRno:number,decision:string):ThunkResult<void>
{
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{

        dispatch(setUiProperty(actionTypes.SET_LOADING, containers.ACTIVITY_DATA_CONTAINER, true));
        dispatch(SetErrorMsgVisible(false));
   
        let JsonPostDocuments = {
            "activityRno": actRno,
            "activityPriority": 0,
            "choice": decision,
            "recipientEmails": []
          };

        dispatch(()=>callProArcApi(buttonActionTypes.CLOSE_ACTIVITY,JsonPostDocuments,wfRno.toString(),actRno.toString())
        .then((response)=>{
                if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                {
                    console.log("Error");
                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                    dispatch(SetErrorMsgVisible(true));
                    dispatch(setUiProperty(actionTypes.SET_LOADING, containers.ACTIVITY_DATA_CONTAINER, false));
                }
                else
                {
                    //reload activities list
                    let json = getMyActivitiesJson;
                    json.activityFilter.ActivityFilterType = "AllActivities";
                    dispatch(()=>callProArcApi(buttonActionTypes.GET_MY_ACTIVITIES,json,"")
                        .then((response)=>{
                                if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                {
                                    console.log("Error");
                                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                                    dispatch(SetErrorMsgVisible(true));
                                    dispatch(setUiProperty(actionTypes.SET_LOADING, containers.ACTIVITY_DATA_CONTAINER, false));
                                }
                                else
                                {
                                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.myActivities, response));
                                    //reload activity
                                    const hText = store.getState().uiItems.headerText;
                                    dispatch(GetWfActivity(wfRno,actRno,hText));  
                                }      
                            }
                        )
                    )
                }
            })
            .catch(error=>
                {
                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(error))); 
                    dispatch(SetErrorMsgVisible(true));
                    dispatch(setUiProperty(actionTypes.SET_LOADING, containers.ACTIVITY_DATA_CONTAINER, false));
                }
            ) 
        )
    }
}

export function GoBack():ThunkResult<void> {
    console.log("GoBack");
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
                // dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.headerText, headerText));  
                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.currentPath, store.getState().uiItems.previousPath.at(-1)));
                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.previousPath, store.getState().uiItems.previousPath.slice(0, -1)));    
    }
}

export function GetDocumentProfile(headerText:string, docRno:number, previousPath:currPathValue):ThunkResult<void> {
    console.log("setHeaderText", headerText);
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{

                dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DATA_CONTAINER, true));
                dispatch(SetErrorMsgVisible(false));


                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.headerText, headerText));  
                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.currentPath, currPathValue.Document));
                //dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.previousPath, [...store.getState().uiItems.previousPath].concat([previousPath])));    
                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.previousPath, [previousPath]));    
                
                
                let JsonPostDocuments = {
                    "docRnos": [-1],
                    "returnOptions": "All"
                    };
                JsonPostDocuments.docRnos = [docRno];

                dispatch(()=>callProArcApi(buttonActionTypes.GET_DOCUMENTS,JsonPostDocuments,"")
                .then((response)=>{
                        if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                        {
                            console.log("Error");
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                            dispatch(SetErrorMsgVisible(true));
                            dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DATA_CONTAINER, false));
                        }
                        else
                        {
                            console.log("Success");
                            let doc = (response as any as PaDocument[])[0];
                            doc.WfComments = doc.Comments.map(x=> {

                                return {
                                    "commentRno": x.CommentId,
                                    "comment": x.Text,
                                    "commentedByUserName": x.CommentedBy.FullName,
                                    "created": x.Created,
                                    "activityName": x.DocumentInfo.ActivityItem.ActivityTemplate.Name,
                                    "docId": x.DocumentInfo.DocId,
                                    "revisionId": x.DocumentInfo.RevisionId,
                                    "commentedByUserRno": x.CommentedBy.UserRno,
                                    "commentedByUserId": x.CommentedBy.UserId,
                                    "commentSequence": x.CommentSequence,
                                    "commentType": x.CommentType,
                                    "fileRno": -1,
                                    "isDeleted": false,
                                    "parentCommentRno": x.ParentCommentId,
                                    "attachmentsCount": -1,
                                    "fileName": "",
                                    "documentRno": x.DocumentInfo.DocRno,
                                    "revisionRno": x.DocumentInfo.RevisionRno,
                                    "repositoryRno": x.DocumentInfo.ArchiveId,
                                    "workflowRno": -1,
                                    "workflowTemplateRno": -1,
                                    "workflowClassRno": -1,
                                    "workflowName": "",
                                    "activityRno": -1,
                                    "activityId": -1,
                                    "Attachments": x.Attachments.map(y=>{return {"FileRno": y.FileRno, "OriginalFileName": y.OriginalFileName, "Extension": y.Extension }})
                                }
                            })
                            // doc.SelectedRevId = doc.CurrentRevision.RevRno;
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.selectedDocument, doc));

                            let JsonPostRevPermisions = {
                                    "docRno": doc.DocRno,
                                    "revRno": doc.CurrentRevision.RevRno
                                };

                            dispatch(()=>callProArcApi(buttonActionTypes.GET_REVISION_PERMISIONS,JsonPostRevPermisions,"")
                                .then((response)=>{
                                        if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                        {
                                            console.log("Error");
                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                                            dispatch(SetErrorMsgVisible(true));
                                            dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DATA_CONTAINER, false));
                                        }
                                        else
                                        {
                                            console.log("Success");
                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.revisionPermisions, [response] ));
                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.selectedRevPermisions, {Attribute: "SelectedRevPermisions", Value: response } ));
                                            dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DATA_CONTAINER, false));
                                        }
                                }))
                        }
                    })
                    .catch(error=>
                        {
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(error))); 
                            dispatch(SetErrorMsgVisible(true));
                            dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DATA_CONTAINER, false));
                        }
                    ) 
                )

            }
}    

export function StartInnmeldingsWorkflow(doc:PaDocument, revRno:number, wfDesc:string, wfNotes:string, wfType: wfRetteType):ThunkResult<void> {
    console.log("StartInnmeldingsWorkflow", doc.DocRno, wfDesc, wfNotes);
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
        dispatch(setUiProperty(actionTypes.SET_LOADING,containers.DATA_CONTAINER, true));
        dispatch(SetErrorMsgVisible(false));
        const appSettings = store.getState().appSettings;
        let JsonPostDocuments = [{"documentRno":doc.DocRno}]
        let wfTypeNumber = appSettings.ertms.type;
        let wfClassNumber = appSettings.ertms.class;
        if(wfType === wfRetteType.retteflyt)
        {
            wfTypeNumber = appSettings.retteflyt.type;
            wfClassNumber = appSettings.retteflyt.class;
        }
        
        dispatch(()=> 
            callProArcApi(buttonActionTypes.GET_WF_DEFAULT_RECIPIENTS,JsonPostDocuments,wfTypeNumber.toString())
                .then((response)=>{
                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                        {
                            console.log("Error saving WF");
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                            dispatch(SetErrorMsgVisible(true));
                            dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DATA_CONTAINER, false));
                        }
                        else
                        {
                            let wfItem = {
                                workflowMessage: {  
                                        workflowRno: -1,
                                        name: "",
                                        description: wfDesc,
                                        notes: wfNotes,
                                        workflowTemplateRno: wfTypeNumber,
                                        workflowClassRno: wfClassNumber,
                                        plannedCloseDate: "1990-01-01T00:00:00",
                                        calendar: "",
                                        rfiMandatory: false,
                                        estimatedDays: 0,
                                        sentDate: "1990-01-01T00:00:00",
                                        createdDate: new Date().toISOString().substring(0,19)
                                    },
                                documents: [{
                                    sequenceNo: 1,
                                    revisionRno: revRno,
                                    forInfoOnly: false,
                                    documentRno: doc.DocRno,
                                    repositoryRno: doc.DbRno
                                }],
                                recipients: (response as unknown as any).items.filter((x:wfRecipient)=>x.recipientId!=="")
                            }        
                            
                            console.log("wfItem",wfItem);

                            dispatch(()=> {
                                callProArcApi(buttonActionTypes.CREATE_WORKFLOW,wfItem,"")
                                .then((response)=>{
                                            if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                            {
                                                console.log("Error saving WF");
                                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                                                dispatch(SetErrorMsgVisible(true));
                                                dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DATA_CONTAINER, false));
                                            }
                                            else
                                            {
                                                console.log("Success");
                                                let DisRno = response as unknown as number;
                                                let wfItemStart:any = startWfJson;
                                                const currentDate = new Date();
                                                // Format the date as "YYYY-MM-DDTHH:mm:ss"
                                                // const formattedDate = currentDate.toISOString().split('.')[0];
                                                // wfItemStart.startDate = formattedDate;

                                                //need to formtat with 00:00:00 otherwise activities can not be closed
                                                const formattedDate = currentDate.toISOString().split('T')[0];
                                                wfItemStart.startDate = `${formattedDate}T00:00:00`;
                                                dispatch(()=>                                                    
                                                    callProArcApi(buttonActionTypes.START_WORKFLOW,wfItemStart,DisRno.toString())
                                                    .then((response)=>{
                                                        console.log("Start workflow response", response);
                                                        if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                                        {
                                                            console.log("Error starting WF");
                                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                                                            dispatch(SetErrorMsgVisible(true));
                                                            dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DATA_CONTAINER, false));
                                                        }
                                                        else
                                                        {
                                                            console.log("WF startet",response);
                                                            //reload activities and redirect there
                                                            //reload activities list
                                                            let json = getMyActivitiesJson;
                                                            json.activityFilter.ActivityFilterType = "AllActivities";
                                                            dispatch(()=>callProArcApi(buttonActionTypes.GET_MY_ACTIVITIES,json,"")
                                                                .then((response)=>{
                                                                        if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                                                        {
                                                                            console.log("Error");
                                                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                                                                            dispatch(SetErrorMsgVisible(true));
                                                                            dispatch(setUiProperty(actionTypes.SET_LOADING, containers.ACTIVITY_DATA_CONTAINER, false));
                                                                        }
                                                                        else
                                                                        {
                                                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.myActivities, response));
                                                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.currentPath, currPathValue.Activities));
                                                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.previousPath, [])); 
                                                                            dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DATA_CONTAINER, false));
                                                                            // const headerText = store.getState().uiItems.headerText;
                                                                            // const previousPath = store.getState().uiItems.previousPath[0];
                                                                            // dispatch(GetDocumentProfile(headerText,docRno,previousPath))
                                                                        }      
                                                                    }
                                                                )
                                                            )
                                                        }
                                                    })
                                                ) 
                                            }
                                        })
                            })
                        }
                    }
                )
                .catch(error=>
                    {
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(error))); 
                        dispatch(SetErrorMsgVisible(true));
                        dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DATA_CONTAINER, false));
                    }
                )  
        )
    }    
} 

export function SetSelectedRevision(docRno:number, revId:number):ThunkResult<void> {
    console.log("SetSelectedRevision");
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
                const revPerms:RevisionPermisions[] = store.getState().uiItems.revisionPermisions;
                if(revPerms.filter(x=>x.DocRno === docRno && x.RevRno === revId).length === 0)
                {
                    dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DOC_DATA_CONTAINER, true));
                    dispatch(SetErrorMsgVisible(false));

                    let JsonPostRevPermisions = {
                                        "docRno": docRno,
                                        "revRno": revId
                                    };
                    
                    dispatch(()=>callProArcApi(buttonActionTypes.GET_REVISION_PERMISIONS, JsonPostRevPermisions,"" )
                        .then((response)=>{
                                if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                {
                                    console.log("Error");
                                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                                    dispatch(SetErrorMsgVisible(true));
                                    dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DOC_DATA_CONTAINER, false));
                                }
                                else
                                {
                                    console.log("Success");
                                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.revisionPermisions, [...store.getState().uiItems.revisionPermisions].concat([response as any as RevisionPermisions]))); 
                                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.selectedRevPermisions, {Attribute: "SelectedRevPermisions", Value: response } ));
                                    dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DOC_DATA_CONTAINER, false));
                                }
                            })
                            .catch(error=>
                                {
                                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(error))); 
                                    dispatch(SetErrorMsgVisible(true));
                                    dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DOC_DATA_CONTAINER, false));
                                }
                            ) 
                    )
                }
                else
                {
                    const perms = revPerms.filter(x=>x.DocRno === docRno && x.RevRno === revId)[0];
                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.selectedRevPermisions, {Attribute: "SelectedRevPermisions", Value: perms } ));
                }  
            }
} 

export function FavoritesClick(docRno:number, isFavorite:boolean):ThunkResult<void> {
    console.log("FavoritesClick", docRno);
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
        
        dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DATA_CONTAINER, true));
        dispatch(SetErrorMsgVisible(false));
        

        let json = {};
       
        dispatch(()=>(isFavorite === false ? 
                            callProArcApi(buttonActionTypes.ADD_TO_FAVORITES,json,docRno.toString())
                            :callProArcApiDelete(buttonActionTypes.REMOVE_FROM_FAVORITES,json,docRno.toString())) 
            .then((response)=>{
                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                    {
                        console.log("Error");
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                        dispatch(SetErrorMsgVisible(true));
                        dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DATA_CONTAINER, false));
                    }
                    else
                    {
                        console.log("Success");
                        //load favorites
                        let json:any = {};        
                        dispatch(()=>callProArcApi(buttonActionTypes.GET_FAVORITE_DOCS,json,"")
                            .then((response)=>{
                                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                    {
                                        console.log("Error");
                                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                                        dispatch(SetErrorMsgVisible(true));
                                        dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DATA_CONTAINER, false));
                                    }
                                    else
                                    {
                                        console.log("Success");
                                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.favoriteDocuments, (response as unknown as any).items.filter((x:PaDocumentV2)=>x.repositoryRno===30)));
                                        dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DATA_CONTAINER, false));
                                    }
                                }) 
                            )  
                    }
                })
                .catch(error=>
                    {
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(error))); 
                        dispatch(SetErrorMsgVisible(true));
                        dispatch(setUiProperty(actionTypes.SET_LOADING, containers.DATA_CONTAINER, false));
                    }
                ) 
            )
    }
}

export function SetErrorMsgVisible(val:boolean):ThunkResult<void> {
    console.log("SetErrorMsgVisible",val);
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{    
        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMsgVisible, val));  
        //clear error message 
        if(val === false) {dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, "")); }
    }    
} 

export function LoadPdf(fileRno:number,clientSide:boolean, mode: pdfMode, saveButtonMode: saveButtonMode):ThunkResult<void> {
    console.log("LoadPdf",fileRno);
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
        dispatch(setUiProperty(actionTypes.SET_LOADING,containers.PDF_VIEWER_INIT, true));     
        let JsonPost= {
                "fileOpenArguments": {
                    "FileOperation": "GetFile",
                    "FileOperationComment": "",
                    "GenerateFileNameSyntax": {},
                    "FileExportNameType": "Default",
                    "GetReferencedFiles": false,
                    "FileRno": fileRno,
                    "SiteRno": 2,
                    "IsStreamingRequired": true,
                    "IsReferencedFile": false,
                  }
            }
        dispatch(()=>callProArcApi(buttonActionTypes.OPEN_FILE,JsonPost,"")
            .then((response)=>{
                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                    {
                        console.log("Error");
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response)));
                        // dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.PDF_VIEWER_CONTAINER, true));
                        dispatch(setUiProperty(actionTypes.SET_LOADING,containers.PDF_VIEWER_CONTAINER, false));
                        dispatch(setUiProperty(actionTypes.SET_LOADING,containers.PDF_VIEWER_INIT, false));
                        
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.currentPath, currPathValue.HomePage));
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.previousPath, []));
                        dispatch(SetErrorMsgVisible(true));
                    }
                    else
                    {
                        console.log("Success");
                        let infoFile =  (response as unknown as OpenFileInfo)
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.OpenFileInfo, infoFile)); 
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.pdfViewerClientSide, clientSide)); 
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.pdfViewerMode, mode));     
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.pdfViewerSaveButtonMode, saveButtonMode));                      
                        dispatch(setUiProperty(actionTypes.SET_LOADING,containers.PDF_VIEWER_INIT, false));
                        callProArcApiGet(buttonActionTypes.LOG_PDF_VIEW, "");
                    }
            })
            .catch(error=>
                {
                    console.log("pdf load catch");
                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(error)));      
                    dispatch(setUiProperty(actionTypes.SET_LOADING,containers.PDF_VIEWER_CONTAINER, false));
                    dispatch(setUiProperty(actionTypes.SET_LOADING,containers.PDF_VIEWER_INIT, false));
                    
                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.currentPath, currPathValue.HomePage));
                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.previousPath, []));
                    dispatch(SetErrorMsgVisible(true));
                }
            )   
        );      
    }            
};

export function ImportFile(blob:Blob, fileInfo: OpenFileInfo):ThunkResult<void> {
    console.log("ImportFile")
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
            const saveBtnMode = store.getState().uiItems.pdfViewerSaveButtonMode;
            //upload syncronously               
            let p = Promise.resolve();
            let pathOnServer ="";
            dispatch(setUiProperty(actionTypes.SET_LOADING,containers.PDF_VIEWER_INIT, true));
            console.log("PDF_VIEWER_INIT loading true")
            dispatch(()=>p = p.then(() => 
                {
                    console.log("Upload file", fileInfo.File.Name);
                    if(blob.size<20000000)
                    {
                        return uploadBlobToDssWithoutChunking(blob,fileInfo.File.Name)
                            .then(response => response.json())
                            .then(success => {
                                console.log("uploadFileToDss With OUT Chunking success");
                                pathOnServer = success.serverFilePath;
                            })
                            .catch(error => {
                                console.log("catch upload file",error);
                                pathOnServer = "";
                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(error)));      
                                dispatch(setUiProperty(actionTypes.SET_LOADING,containers.PDF_VIEWER_CONTAINER, false));
                                dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.PDF_VIEWER_CONTAINER, false));
                            }); 
                    }
                    else
                    {
                        return uploadBlobToDssWithChunking(blob,fileInfo.File.Name, dispatch)
                            .then(response => response.json())
                            .then(success => {
                                console.log("uploadFileToDss With Chunking success");
                                pathOnServer = success.serverFilePath;
                            })
                            .catch(error => {
                                console.log("catch upload file",error);
                                pathOnServer = "";
                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(error)));      
                                dispatch(setUiProperty(actionTypes.SET_LOADING,containers.PDF_VIEWER_CONTAINER, false));
                                dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.PDF_VIEWER_CONTAINER, false));
                            }); 
                    }
                })
                .then(()=> {
                    //normal flow
                    if(saveBtnMode=== saveButtonMode.save)
                    {
                        console.log("check out file");
                        let JsonPost = {
                            "fileOpenArguments": {
                                "FileOperation": "CheckOutFile",
                                "FileOperationComment": "",
                                "GenerateFileNameSyntax": {},
                                "FileExportNameType": "Default",
                                "GetReferencedFiles": false,
                                "FileRno": fileInfo.File.FileRno,
                                "SiteRno": 2,
                                "IsStreamingRequired": true,
                                "IsReferencedFile": false,
                            }
                        }
                        return dispatch(()=>                        
                            callProArcApi(buttonActionTypes.OPEN_FILE, JsonPost,"")
                            .then((response)=>{
                                if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                {
                                    console.log("Error checking out file");
                                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response)));
                                    dispatch(setUiProperty(actionTypes.SET_LOADING,containers.PDF_VIEWER_CONTAINER, false)); 
                                    dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.PDF_VIEWER_CONTAINER, false));    
                                }
                                else
                                {
                                
                                    console.log("Success");
                                    // console.log("pathOnServer",pathOnServer);
                                    let JsonPostCheckIn= {
                                        "argument": {
                                        "KeepCheckedOut": false,
                                        "ForComments": false,
                                        "FileRno": 0,
                                        "FilePath": "string"
                                        }
                                    }
                                    JsonPostCheckIn.argument.FileRno=fileInfo.File.FileRno;
                                    JsonPostCheckIn.argument.FilePath=pathOnServer;
                                    console.log("check in file");
                                    return dispatch(()=> 
                                        callProArcApi(buttonActionTypes.CHECK_IN_FILE,JsonPostCheckIn,"")
                                                .then((response)=>{
                                                        if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                                        {
                                                            console.log("Error check in file");
                                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response)));    
                                                            dispatch(setUiProperty(actionTypes.SET_LOADING,containers.PDF_VIEWER_INIT, false));
                                                            dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.PDF_VIEWER_CONTAINER, false));
                                                        }
                                                        else
                                                        {
                                                            console.log("Success check IN - reload" );
                                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify({succeded: true, Message:"File checked-in"})));
                                                            dispatch(LoadPdf(fileInfo.File.FileRno, true, pdfMode.edit,saveButtonMode.save));
                                                            //dispatch(setUiProperty(actionTypes.SET_LOADING,containers.PDF_VIEWER_INIT, false));
                                                            //console.log("PDF_VIEWER_INIT loading false")
                                                        }
                                                    })
                                            )
                                }
                            })
                        )
                    }
                    else
                    {
                        //as comment and attachment
                        const openedFile = store.getState().uiItems.OpenFileInfo!.File;
                        let json:any = {
                            "commentRno": 0,
                            "comment": `retteunderlag (${store.getState().oidc?.profile.sub})`,
                            "commentedByUserId": store.getState().oidc?.profile.sub,
                            "commentType": 0,
                            "documentRno": openedFile.DocRno
                            //"revisionRno": 3, to add to specific revision
                        };
                        let action = buttonActionTypes.ADD_DOC_COMMENT;
                        

                        //if(store.getState().uiItems.currentPath === currPathValue.WfActivity)
                        console.log("Action check")
                        // console.log(store.getState().uiItems.currentPath === currPathValue.PdfTron,store.getState().uiItems.previousPath[0].toString() === currPathValue.WfActivity.toString())
                        if(store.getState().uiItems.currentPath === currPathValue.PdfTron 
                            && store.getState().uiItems.previousPath[store.getState().uiItems.previousPath.length-1].toString() === currPathValue.WfActivity.toString() )
                        {
                            
                            action = buttonActionTypes.ADD_WF_COMMENT;
                            json = {
                                "commentRno": 0,
                                "comment": `retteunderlag (${store.getState().oidc?.profile.sub})`,
                                "commentedByUserId": store.getState().oidc?.profile.sub,
                                "commentType": 10,
                                "workflowRno": store.getState().uiItems.selectedActivity!.WorkflowItem.Id,
                                "activityRno": store.getState().uiItems.selectedActivity!.Id,
                                "documentRno": openedFile.DocRno,
                                "revisionRno": openedFile.RevRno
                            };    
                        }
                        return dispatch(()=>
                            (action === buttonActionTypes.ADD_WF_COMMENT ? callProArcApi(buttonActionTypes.ADD_WF_COMMENT,json,store.getState().uiItems.selectedActivity!.WorkflowItem.Id.toString(),store.getState().uiItems.selectedActivity!.Id.toString())
                                :callProArcApi(buttonActionTypes.ADD_DOC_COMMENT,json,openedFile.DocRno.toString()))
                            .then((response)=>{
                                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                    {
                                        console.log("Error");
                                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                                        dispatch(SetErrorMsgVisible(true));
                                        dispatch(setUiProperty(actionTypes.SET_LOADING, containers.ACTIVITY_DATA_CONTAINER, false));
                                    }
                                    else
                                    {
                                        console.log("Success comment added");
                                        // console.log(response);
                                        // const obj = {
                                        //   "rel": "GetWorkflowActivityComment",
                                        //   "href": "/api/workflow/418490/activity/1299142/comments/230130",
                                        //   "method": "GET"
                                        // };

                                        const href = (response as unknown as any).href;
                                        const commNumber = href.substring(href.lastIndexOf('/') + 1);
                                        //add comment file
                                        // console.log("pathOnServer",pathOnServer);
                                        const JsonImportCommFIle= {
                                            "commentFiles":[
                                                {
                                                    "CommentId": commNumber,
                                                    "Name": "retteunderlag.pdf",
                                                    "OriginalFileName": openedFile.Name,
                                                    "MetaItems":[
                                                            {	
                                                                "Name":"FilePath",
                                                                "Value": pathOnServer,
                                                                "HasMultipleValues":false
                                                            }
                                                        ],
                                                    "DocRno": openedFile.DocRno
                                                }
                                            ]
                                        }
   
                                        console.log("Import com file");
                                        return dispatch(()=> 
                                            callProArcApi(buttonActionTypes.IMPORT_COMM_FILE,JsonImportCommFIle,"")
                                                    .then((response)=>{
                                                            if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                                            {
                                                                console.log("Error import comm file");
                                                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response)));    
                                                                dispatch(setUiProperty(actionTypes.SET_LOADING,containers.PDF_VIEWER_INIT, false));
                                                                dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.PDF_VIEWER_CONTAINER, false));
                                                            }
                                                            else
                                                            {
                                                                console.log("Success import comm file - reload" );
                                                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify({succeded: true, Message:"Comm file imported"})));
                                                                //dispatch(LoadPdf(fileInfo.File.FileRno,true, pdfMode.edit));
                                                                const selectedAct = store.getState().uiItems.selectedActivity!;
                                                                
                                                                //find and reload correct comment file instead here
                                                                let JsonPostDocuments = {
                                                                    "docRnos": [-1],
                                                                    "returnOptions": "All"
                                                                    };
                                                                JsonPostDocuments.docRnos = selectedAct.WfDocuments.map((x:wfDocument)=>x.documentRno);
                                                
                                                                return callProArcApi(buttonActionTypes.GET_DOCUMENTS,JsonPostDocuments,"")
                                                                    .then((response)=>{
                                                                            if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                                                            {
                                                                                console.log("Error getPaDocuments");
                                                                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response))); 
                                                                                dispatch(SetErrorMsgVisible(true));
                                                                            }
                                                                            else
                                                                            {
                                                                                console.log("Success getPaDocuments");
                                                                                let wfDocs = (response as any as PaDocument[]);
                                                                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.wfDocuments, {Attribute: "PaDocuments", Value: wfDocs } ));
                                                                                const act = store.getState().uiItems.selectedActivity!;
                                                                                const allComments:PaDocumentComments[] = act.PaDocuments.flatMap((doc:PaDocument) => doc.Comments);
                                                                                const commentJustsaved= allComments.filter(x=>x.CommentId.toString() === commNumber.toString()).length >0 
                                                                                                            ? allComments.filter(x=>x.CommentId.toString() === commNumber.toString())[0]
                                                                                                            : allComments[0];
                                                                                // console.log("com just added",commentJustsaved);
                                                                                const lastAttachemnt = commentJustsaved.Attachments[commentJustsaved.Attachments.length - 1];

                                                                                return getActComments(dispatch,act.WorkflowItem.Id,act.Id)
                                                                                        .then(()=>{
                                                                                            console.log("Success comments refreshed");
                                                                                            console.log("Add attachments info from doc comms if present");
                                                                                            let sellActivty:activityItem = store.getState().uiItems.selectedActivity!;
                                                                                            const comms = sellActivty.WfComments.map(x=>{
                                                                                                const commId = x.commentRno;
                                                                                                const allPaComments = sellActivty.PaDocuments.flatMap(doc => doc.Comments);
                                                                                                if(allPaComments.filter(x=>x.CommentId === commId).length>0)
                                                                                                {
                                                                                                    console.log("add attachment info to comment")
                                                                                                    x.Attachments = allPaComments.filter(x=>x.CommentId === commId)[0].Attachments;
                                                                                                }
                                                                                                else
                                                                                                {
                                                                                                    x.Attachments = [];
                                                                                                }
                                                                                                return x;
                                                                                            });
                                                                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.wfDocuments, {Attribute: "WfComments", Value: comms } ));
                                                                                            dispatch(LoadPdf(lastAttachemnt.FileRno, true, pdfMode.edit,saveButtonMode.save));
                                                                                        })
                                                                                
                                                                                //dispatch(LoadPdf(fileInfo.File.FileRno, true, pdfMode.edit,saveButtonMode.save));
                                                                                //dispatch(setUiProperty(actionTypes.SET_LOADING,containers.PDF_VIEWER_INIT, false));
                                                                                //console.log("PDF_VIEWER_INIT loading false")

                                                                            }
                                                                        })


                                                                

                                                            }
                                                        })
                                                )
                                    }
                                }) 
                            )
                    }
                })
                .catch(error => {
                    console.log(error);
                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(error)));      
                    dispatch(setUiProperty(actionTypes.SET_LOADING,containers.PDF_VIEWER_CONTAINER, false));
                    dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.PDF_VIEWER_CONTAINER, false));
                })
            );   
    }
}

export function uploadBlobToDssWithoutChunking(blob:Blob,filename:string):Promise<Response>
{
    console.log("uploadBlobToDssWithoutChunking");    
    var formData = new FormData();
    const file = new File([blob], filename, { type: blob.type });
    //formData.append(filename, blob, filename);
    formData.append('file[1]', file);
    //proarc-dss
    const dssUrl = `${apiUrl}/proarc-dss/Upload`;
    return fetch(dssUrl, {
            // content-type header should not be specified!
            method: 'POST',
            headers: new Headers ({
                'Accept': '*/*',
                authorization: `Bearer ${store.getState().oidc?.access_token}`,
                "Ocp-Apim-Subscription-Key": store.getState().appSettings.apimSubKey
                }),
            body: formData,
            })            
}

export function uploadBlobToDssWithChunking(blob:Blob,filename:string,dispatch:ThunkDispatch<IState,undefined,AppActions>):Promise<Response>
{
    const file = new File([blob], filename, { type: blob.type });
    console.log("uploadFileToDssWithChunking");
    // dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, `{"succeded": true, "Message":"Uploading ${file.name}"}`));      
    return new Promise<Response>((resolve) =>{
        const chunkSize = 10000000
        const _totalChunksCount = file.size % chunkSize === 0 ? file.size / chunkSize : Math.floor(file.size / chunkSize) + 1;
        const endSessionUrl = `${apiUrl}/proarc-dss/EndSession`;
        const createSessionUri = `${apiUrl}/proarc-dss/CreateSession?fileName=${file.name}`;

        return fetch(createSessionUri, {
                method: "GET",
                headers: new Headers ({
                        "Cache-Control": "no-cache",
                        "Content-Type": "application/json",
                        credentials: "include",
                        Authorization: `Bearer ${store.getState().oidc?.access_token}`,
                        }),
            })
            .then((res) => res.text())
            .then((text) => 
                {
                    // console.log("CreateSession text",text,text.length);
                    let response:any = JSON.parse(text);
                    //{"sessionId":"8e686cd1-5388-48ea-8619-0d8801f3a4c6",
                    //"fileUploadUrl":"https://proarcutv.utv.banenor.no:82/api/file/upload/8e686cd1-5388-48ea-8619-0d8801f3a4c6",
                    //"supportsParallelUpload":false}
                    let endSessionUri = `${endSessionUrl}?id=${response.sessionId}`;
                    let p = Promise.resolve();
                    let done = false;
                    [...Array(_totalChunksCount).keys()].forEach(chunkId => 
                       //upload chunks 
                        p = p.then(() => {
                                console.log("chunks number", chunkId);
                                if(chunkId===_totalChunksCount-1) done=true;
                                let beginingOfTheChunk = chunkSize * chunkId;
                                let endOfTheChunk = chunkSize * (chunkId + 1);
                                let chunk = file.slice(beginingOfTheChunk, endOfTheChunk);
                                // if(endOfTheChunk>file.size) endOfTheChunk = file.size-1;
                                if(endOfTheChunk>file.size) 
                                {
                                    endOfTheChunk = file.size;
                                    chunk = file.slice(beginingOfTheChunk);
                                }
                                return uploadChunk(response.fileUploadUrl,chunk,file.name,beginingOfTheChunk,endOfTheChunk,file.size);
                            }
                        )
                        .finally(()=> {
                            console.log("chunk done");
                            if(done) 
                            {
                                console.log("All chunks done close session");
                                return fetch(endSessionUri, {
                                    method: "POST",
                                    headers: new Headers ({
                                            "Cache-Control": "no-cache",
                                            "Content-Type": "application/json",
                                            credentials: "include",
                                            Authorization: `Bearer ${store.getState().oidc?.access_token}`,
                                            }),
                                    })
                                    .then(response => response.json())
                                    .then(success => {
                                        console.log("uploadFileToDss With Chunking success",success);
                                        // dispatch(updateFileImportStage({Name:file.name,Property:uiItemNames.pathOnDss,Value:success.serverFilePath})); 
                                        // dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, `{"succeded": true, "Message":"File uploaded to DSS ${file.name}"}`));  
                                    })
                                    .then(()=> {
                                        let resp:any;
                                        resolve(resp);
                                    })
                                    .catch(error => {
                                        // dispatch(updateFileImportStage({Name:file.name,Property:uiItemNames.errored,Value:true})); 
                                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, `{"succeded": false, "Message":"Error Uploading ${file.name}"}`));  
                                        let resp:any;
                                        resolve(resp);
                                        console.log(error);
                                    });  
                            }
                            else 
                            {
                                console.log(`Not done yet done, at chunk: ${chunkId}, done: ${done}` );
                            }
                        })
                    )
                }
            )
            .catch(error => {
                console.log("uploadFileToDss With Chunking catch");
                // dispatch(updateFileImportStage({Name:file.name,Property:uiItemNames.errored,Value:true})); 
                console.log(error);
            })  
    })      
}

export function uploadChunk(url:string,chunk:any,fileName:string,beginingOfTheChunk:number, endOfTheChunk:number,fileSize:number):Promise<void>
{
    console.log("uploadChunk",url,beginingOfTheChunk,endOfTheChunk);  
    var formData = new FormData();

    formData.append('file', chunk, fileName);
    return fetch(url, {
            method: 'POST',
            headers: new Headers ({
                'Accept': '*/*',
                authorization: `Bearer ${store.getState().oidc?.access_token}`,
                "content-disposition": `attachment; filename="${fileName}"`,
                "content-range": `bytes ${beginingOfTheChunk}-${endOfTheChunk-1}/${fileSize}`
                }),
            body: formData,
            })
            .then((res) => res.text())
            .then((text) => 
            {
                // console.log("uploadChunk response", text,text.length);
                return text.length > 0 ? JSON.parse(text) : {}}
            )
            .catch(error => {
                        return error
                    }) 
}

export function toLocaleUTCDateString(date:string, withTime:boolean) {
    const dato = new Date(date);
    const timeDiff = dato.getTimezoneOffset();
    const adjustedDate = new Date(dato.valueOf() - timeDiff * 60000);
    const timeValue =  withTime === true ? " " + adjustedDate.toLocaleTimeString() :"";
    const formatedDate = adjustedDate.toLocaleDateString('no',{day: "2-digit", month: "2-digit", year: "numeric" }); 
    return formatedDate + timeValue;
}

export function getMetaItemValue(metaItemName:string, doc:PaDocument) {
    const metaItems = doc.MetaItems;
    if(metaItems.filter(x=>x.Name.toUpperCase()===metaItemName.toUpperCase()).length>0)
    {
        const metaItem = metaItems.filter(x=>x.Name.toUpperCase()===metaItemName.toUpperCase())[0];
        if(metaItem.HasMultipleValues)
        {
            return metaItem.MultipleValues?.join(",");
        }
        else
        {
            return metaItem.Value;
        }
    }
    else
    {
        return "";
    }

}

function isErrorJsonObject(strData:string) {
    try {
        let Json = JSON.parse(strData);
        if(
            Json.hasOwnProperty("Message") &&  Json.hasOwnProperty("ExceptionMessage") &&  Json.hasOwnProperty("StackTrace")
             &&  Json.hasOwnProperty("InnerException") )
        {
            return true;    
        }
        else
        {
            if(
                Json.hasOwnProperty("errorDetails") &&  Json.hasOwnProperty("errorMessage") //&&  Json.hasOwnProperty("errorType")
            )
            {
                return true;
            }
            else
            {
                if(
                    Json.hasOwnProperty("errorType") &&  Json.hasOwnProperty("errorMessage") //&&  Json.hasOwnProperty("errorType")
                )
                {
                    return true;
                }
                else
                {
                    if(
                    Json.hasOwnProperty("ExceptionMethod") &&  Json.hasOwnProperty("StackTraceString") &&  Json.hasOwnProperty("InnerException") //&&  Json.hasOwnProperty("errorType")
                    )
                    {
                        return true;
                    }
                    else
                    {
                            return false;   
                    } 
                }
            }
        }
    } catch (e) {
        return false;
    }
}




